import { Injectable } from '@angular/core';
import{DataService} from '../../../shared/services/data.service';
import {StorageService} from '../../../shared/services/storage.service';
import { ResponseModel } from '../../../shared/models/response-model.model';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StockJournal2Service {

  constructor(public service:DataService,
    public storageService : StorageService) { }

  insertstockjournalmovement(data:any){
    let url = 'api/app/stockjournalmovement/insertstockjournalmovement';
    return this.service.post(url,data,false).pipe<ResponseModel>(tap((response: any) => {
      if(response.isSuccess == true)
      {
        this.storageService.store("StockJournalId",0);
        this.storageService.resetInvoice.next("StockJournal");
      }
      return response;
      })
    );
  }

  deleteStockJournalMasterItem(data:any):Observable<ResponseModel>{
    let url = "api/app/stockJournalMovement/deleteStockJournalMasterItem";
    const json = JSON.stringify(data);
    return this.service.post(url,data, true).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }

  uploadFile(data: any, metalId: any) :Observable<ResponseModel>{
    let url = "api/app/stockjournalmovement/importstockjournaloption2/"+metalId;
    return this.service.postWithFile(url,data, true,null,true).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
}

export enum StockJournal2ModalTitle{ 
  AddNewItems   = "Add New Items",
  UpdateOldItems  = "Update Old Items",
  CreateStockJournal   = "Create Stock Journal",
}